import { render, staticRenderFns } from "./pickList.vue?vue&type=template&id=5dc7e427&scoped=true"
import script from "./pickList.vue?vue&type=script&lang=js"
export * from "./pickList.vue?vue&type=script&lang=js"
import style0 from "./pickList.vue?vue&type=style&index=0&id=5dc7e427&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7e427",
  null
  
)

export default component.exports